import React from "react";
import Link from "gatsby-link";

const NotFoundPage = () => <main className="container container-page">
		<h1>404 - Not Found</h1>
		<h3>{"We couldn't find the page you were looking for."}</h3>
		<p>
			Go back to the <Link to="/">homepage</Link>.
		</p>
	</main>;

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js